import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
import { NAV_LINKS, COMPANY } from '../mock';
import { Button } from './ui/button';
import BrandLogo from './BrandLogo';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-shadow duration-300 bg-white ${
        scrolled ? 'shadow-md' : 'shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 lg:px-8 h-28">
        <a href="#home" className="flex items-center" aria-label="Singh Logistics WA home">
          <BrandLogo />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <div key={link.label} className="relative group">
              <a
                href={link.href}
                className="text-slate-700 hover:text-[#0d3d5e] text-[15px] font-medium transition-colors flex items-center gap-1"
              >
                {link.label}
                {link.children && <ChevronDown className="w-4 h-4" />}
              </a>
              {link.children && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-white shadow-xl rounded-md border border-slate-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  <div className="py-2">
                    {link.children.map((c) => (
                      <a
                        key={c.label}
                        href={c.href}
                        className="block px-4 py-2.5 text-sm text-slate-600 hover:bg-slate-50 hover:text-[#0d3d5e]"
                      >
                        {c.label}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${COMPANY.phoneRaw}`}>
            <Button className="bg-[#0d3d5e] hover:bg-[#0a324e] text-white rounded-md px-5">
              <Phone className="w-4 h-4 mr-2" /> Call Now
            </Button>
          </a>
          <a href="#contact">
            <Button
              variant="outline"
              className="border-[#0d3d5e] text-[#0d3d5e] hover:bg-[#0d3d5e] hover:text-white rounded-md px-5"
            >
              Get a Quote
            </Button>
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-slate-700"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 shadow-lg">
          <nav className="px-4 py-4 space-y-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setOpen(false)}
                className="block py-2.5 text-slate-700 font-medium border-b border-slate-100"
              >
                {link.label}
              </a>
            ))}
            <div className="pt-4 flex flex-col gap-2">
              <a href={`tel:${COMPANY.phoneRaw}`}>
                <Button className="w-full bg-[#0d3d5e] hover:bg-[#0a324e] text-white">
                  <Phone className="w-4 h-4 mr-2" /> Call Now
                </Button>
              </a>
              <a href="#contact">
                <Button
                  variant="outline"
                  className="w-full border-[#0d3d5e] text-[#0d3d5e]"
                >
                  Get a Quote
                </Button>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
